<template>
	<div>
		绑定规则：默认榜单：读书币排行（管理员在排名列）
		<el-form

		>
			<x-form
				label="学员可获取积分"
				type="boxed"
			>
				<div slot="box">
					<div>
						<el-switch 
							v-model="canCoin"
							@change="saveStatus"
						></el-switch>
					</div>
					<div v-if="canCoin">
						<el-button type="text" @click="openRule">设置积分规则</el-button>
						<div class="coin-list">
							<div
								class="coin-list__item"
								v-for="(item, index) in groupTask"
								:key="index"
							>
								<div class="head">{{item.task_name}}</div>
								<div>{{item.coin_num}}</div>
							</div>
						</div>
					</div>

				</div>
			</x-form>
		</el-form>


		<el-dialog
			title="设置积分获取规则"
			:visible.sync="showRule"
			append-to-body		
		>
			<div style="margin-bottom: 20px">
				<el-tag type="warning">积分获取规则修改后，仅对新产生的用户行为生效，请谨慎修改。</el-tag>
			</div>
			<div
				class="task-input"
				v-for="(item, index) in editTask"
				:key="index"
			>
				<!-- <el-checkbox v-model="item.checked">{{item.task_name}}</el-checkbox> -->
				<span>{{item.task_name}}</span>
				<el-input
					type="number"
					v-model="item.coin_num"
				>
					<span slot="append">个</span>
				</el-input>
				<div style="margin-left: 20px" v-if="item.showDayNum">
					(每日前 
					<el-input
						class="day-num"
						type="number"
						v-model="item.max_finish_num"
					>
					</el-input>

					 次可获得读书币)
				</div>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
import {
	getGroupTaskList,
	saveGroupTask,
	saveGroup,
} from '@/api/group';
import {
	deepClone
} from '@/utils/util';

export default {
	data() {
		return {
			showRule: false,
			canCoin: true,
			groupTask: [],
			editTask: [],
		}
	},
	props: {
		close: Function,
		fetchList: Function,
		detail: Object
	},
	watch: {
		detail: {
			handler(val) {
				if (!val) return

				this.canCoin = val.coin_task_state === 1
				this.fetchCoin()
			},
			immediate: true
		},
		canCoin() {

		}
	},
	methods: {
		saveStatus() {
			saveGroup({
				id: this.detail.id,
				coin_task_state: this.canCoin ? 1 : 0
			}).then(res => {

				this.$message.success('保存成功')

				this.fetchList()
			})
		},
		fetchCoin() {
			getGroupTaskList({
				groupId: this.detail.id
			}).then(res => {
				this.groupTask = res.data
				this.editTask = deepClone(res.data)

				this.editTask.forEach(e => {
					if (e.task_name !== '完成1次打卡') {
						e.showDayNum = true
					}
					e.checked = true
				})
			})
		},
		openRule() {
			this.showRule = true
		},
		confirm() {
			const result = []
			this.editTask.forEach(e => {
				result.push({
					task_id: e.task_id,
					group_id: this.detail.id,
					max_finish_num: e.task_id == 1 ? 1 : (e.max_finish_num - 0),
					coin_num: (e.coin_num - 0)
				})
			})

			saveGroupTask(result).then(res => {
				this.$message.success('保存成功')
				this.fetchCoin()
				this.showRule = false
			})

		}
	}
}
</script>

<style lang="less">
.el-dialog__body {
	padding-left: 40px;
}
.coin-list {
	display: flex;
	margin-left: 96px;
	&__item {
		&:last-child {
			border-right: 1px solid #f1f1f1;
		}
		div {
			padding: 0 10px;
			border-left: 1px solid #f1f1f1;
			border-bottom: 1px solid #f1f1f1;
		}
		.head {
			background: #f2f2f2;
			border-top: 1px solid #f1f1f1;
		}
	}
}
.task-input {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	.el-input {
		width: 120px;
		margin-left: 12px;
		
		.el-input__inner {
			padding-right: 0;
		}
		.el-input-group__append {
			padding: 0 10px;
		}
		&.day-num {
			width: 70px;
			margin-left: 4px;
			margin-right: 4px;
		}
	}

}
</style>